import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class PushNotificationService {
    cancelNotification: any = null;
    constructor() {
    }

    init() {
        this.cancelNotification = null;

        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register('/ngsw.js').then((registration) => {
                // Registration was successful
                console.log('ServiceWorker registration successful with scope: ', registration.scope);
            }, function (err) {
                // registration failed :(
                console.log('ServiceWorker registration failed: ', err);
            });
        }
    }

    get isNotificationAllowed() {
        //console.log(Notification.permission);
        return Notification.permission == "granted";
    }

    //request For Browser Notification Access regarding any elevator call
    requestForNotificationAccess(callBack?: any) {
        if (Notification.permission !== "granted") {
            Notification.requestPermission().then((permission: any) => {
                //console.log(permission);
                if (callBack) {
                    callBack(permission == "granted");
                }
            });
        }
    }

    clearTimeout() {
        if (this.cancelNotification != null) {
            clearTimeout(this.cancelNotification);
            this.cancelNotification = null;
        }
    }

    //Show browser notifications regarding any elevator call
    showNotification(data: any) {
        this.requestForNotificationAccess(null);

        return new Promise((resolve, reject) => {
            var messageChannel = new MessageChannel();
            messageChannel.port1.onmessage = (event) => {
                if (event.data.error) {
                    reject(event.data.error);
                } else {
                    resolve(event.data);
                }
            };

            if (this.cancelNotification) {
                clearTimeout(this.cancelNotification);
                this.cancelNotification = null;
            }

            navigator.serviceWorker.ready.then((serviceWorkerReg: any) => {
                // Return the subscription
                return serviceWorkerReg.pushManager.getSubscription();
            })
                .then((subscription: any) => {
                    if (!subscription) {
                        //No subscription
                        //console.log("No subscription: ");
                    }

                    if (navigator.serviceWorker != null) {
                        // Send data to service worker
                        if (navigator.serviceWorker.controller?.postMessage != null) {
                            navigator.serviceWorker.controller.postMessage({ command: 1, unitId: data.unitId, message: data.body, isHidden: data.isHidden }, [messageChannel.port2]);
                        }
                    }
                })

            if (data.timeout != null) {
                this.cancelNotification = setTimeout(() => {
                    var options = { tag: data.unitId };

                    navigator.serviceWorker.ready.then((registration: any) => {
                        registration.getNotifications(options).then((notifications: any) => {
                            // do something with your notifications
                            this.cancelNotification = null;

                            if (notifications.length > 0) {
                                if (notifications[0].close) {
                                    notifications[0].close();
                                }
                            }
                        })
                    });
                }, data.timeout);
            }
        });
    }

    //Close existing notifications  regarding any elevator call
    closeNotification(tag: any = null) {
        let options = (tag== null? {}: { tag: tag });

        if (this.cancelNotification) {
            clearTimeout(this.cancelNotification);
            this.cancelNotification = 0;
        }

        navigator.serviceWorker.ready.then((registration: any) => {
            registration.getNotifications(options).then((notifications: any) => {
                // do something with your notifications 
                if (notifications.length > 0) {
                    if (notifications[0].close) {
                        notifications[0].close();
                    }
                }
            });
        });
    }
}